// extracted by mini-css-extract-plugin
module.exports = {"caption":"casestudy-carousel-module--caption--2OEjx"};